import Vue from 'vue'
import App from './App'
import router from './router'
require('es6-promise').polyfill();
import teras from './teras'

import ElementUI from 'element-ui'
import 'element-ui/lib/theme-default/index.css'
import locale from 'element-ui/lib/locale/lang/it'
Vue.use(ElementUI, { locale })

import axios from 'axios'
import VueAxios from 'vue-axios'
Vue.use(VueAxios, axios)
if (process.env.NODE_ENV != 'development')
  axios.defaults.baseURL = teras.urlsite

axios.defaults.validateStatus = function (status) {
  return status >= 200 && status < 300 && status!=210; 
}

import './css/grid.css'
import './css/layout.css'

import progetti from './progetti'
teras.progetti = progetti
teras.SortDesc(teras.progetti, 'peso', 'int')
//console.log(teras.progetti)

//require('./js/carousel.js')

import VueAnalytics from 'vue-analytics'
const googleAnalyticsId = 'UA-2826949-15'
Vue.use(VueAnalytics, { id: googleAnalyticsId, router: router, debug: true })



router.beforeEach(function (to, from, next) {
  //window.scrollTo(0, 0)
  console.log(to)
  teras.mobMmenu = false
  /*
  if(teras.device()=='mobile' && to.fullPath.toLowerCase().indexOf('-mobile') == -1){
    next(to.fullPath+'-mobile')
  }else{
    next()
  }
  */
  next()
})


Vue.prototype.$teras = teras
new Vue({
  el: '#app',
  router,
  data:{
    teras
  },
  template: '<App/>',
  components: { App }
}) 


// WEBPACK FOOTER //
// ./src/main.js